import { render } from "./RedirectHub.vue?vue&type=template&id=48120878"
import script from "./RedirectHub.vue?vue&type=script&lang=js"
export * from "./RedirectHub.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__